import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingWrapper from "../../../common/loading-wrapper";
import { StackedBarChart, DiscreteColorLegend, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { colorScaleCategorical } from "@unifiedpatents/euclid-react/lib/helpers/colors";
import { removeOutlierByPercentile, nestedObjectsToGroupedSeries } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import { withChartConfig } from "../../../common/chart-config-hoc";
import { getPublicationByDate, getPublicationByDateAndField } from "../../../../services/api-patents";
import * as Colors from "@unifiedpatents/euclid-react/lib/helpers/colors";

const colorScale = colorScaleCategorical();

const COLOR_MAP = {
  "ex parte": Colors.blue400,
  ptab: Colors.orange400,
  Count: Colors.blue400,
  us: Colors.blue500,
  gb: Colors.blue200,
  ep: Colors.grey500,
  de: Colors.grey200,
  jp: Colors.orange300
};

class DateHistogram extends Component {
  static propTypes = {
    filter: PropTypes.object,
    fieldDate: PropTypes.string,
    field2: PropTypes.string,
    colorMap: PropTypes.object
  };

  state = {
    data: [],
    dataRaw: [],
    loading: false
  };

  componentDidMount() {
    this._getData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this._getData(nextProps);
    }
  }

  render() {
    const { field2 } = this.props;
    return (
      <LoadingWrapper loading={this.state.loading} spinSize="large" style={{ minHeight: 400 }}>
        {this._renderChart()}
        {field2 ? this._renderLegend() : null}
      </LoadingWrapper>
    );
  }

  _renderChart = () => {
    const { data } = this.state;
    const FlexibleStackedBarChart = withChartConfig(makeWidthFlexible(StackedBarChart), { data });
    return (
      <FlexibleStackedBarChart
        data={data}
        height={500}
        margin={{ left: 75, top: 40 }}
        tickLabelAngleX={-30}
        tickFormatY={val => parseInt(val).toLocaleString()}
        tooltipValueFormat={val => val.toLocaleString()}
        colorMap={COLOR_MAP}
      />
    );
  };

  _renderLegend = () => {
    const field2Keys = this.state.data.map(d => d.k);
    return field2Keys.length > 0 && <DiscreteColorLegend orientation="horizontal" items={field2Keys.map(key => ({ title: key, color: COLOR_MAP[key] }))} colors={[...field2Keys].map(colorScale)} />;
  };

  _setDuration = props => {
    let filter = props.filter;
    if (filter[props.fieldDate]) {
      return filter;
    }
    const duration = `${new Date().getFullYear() - 40}-01-01--`;
    return { ...filter, [props.fieldDate]: duration };
  };

  _getData = props => {
    this.setState({ loading: true });
    const newFilter = this._setDuration(props);
    const { fieldDate, field2 } = props;
    const apiCallPromise = field2 ? getPublicationByDateAndField(newFilter, fieldDate, field2) : getPublicationByDate(newFilter, fieldDate);
    apiCallPromise
      .then(res => {
        this.setState({
          data: this._reformatData(res),
          dataRaw: res,
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          data: [],
          dataRaw: [],
          loading: false
        });
      });
  };

  _arrayToObj = (arr, key, v, keyConverter = undefined) => {
    let obj = {};
    arr.forEach(ele => {
      const objKey = keyConverter ? keyConverter(ele[key]) : ele[key];
      obj[objKey] = ele[v];
    });
    return obj;
  };

  _reformatData = data => {
    const { field2 } = this.props;
    const toLabel = ts => new Date(ts).getUTCFullYear();
    if (field2) {
      let formatedData = this._arrayToObj(data, "key", "value", toLabel);
      Object.keys(formatedData).forEach(key => {
        formatedData[key] = this._arrayToObj(formatedData[key], "key", "doc_count");
      });
      return removeOutlierByPercentile(nestedObjectsToGroupedSeries(formatedData), 99);
    } else {
      const formatedData = data.map(e => ({ k: toLabel(e.key), v: e.doc_count }));
      return [{ k: "Count", v: removeOutlierByPercentile(formatedData, 99) }];
    }
  };
}

export default DateHistogram;
